'use client';

import '@/app/globals.css';
import EneasSVG from '@/assets/svg/EneasSVG';
import BackButton from '@/components/common/BackButton';
import { ErrorAlert } from '@venienergygroup/shared-components';
import { SignoutButton } from '@/components/user-profile/SignoutButton';
import { authClient } from '@/lib/auth-client';
import { FaroErrorBoundary } from '@grafana/faro-react';
import { dmSans } from '@/lib/fonts';

const GlobalError = () => {
  return (
    <html lang="en">
      <body
        className={`${dmSans.className} max-w-screen overflow-x-hidden bg-veni-green-900 antialiased`}
      >
        <main className="relative flex h-svh w-svw items-center justify-center bg-[#ECF3F1]">
          <BackButton />
          <FaroErrorBoundary>
            <GlobalErrorSignout />
          </FaroErrorBoundary>
          <div className="flex flex-col items-center gap-y-8">
            <EneasSVG
              aria-description={'Eneas logo'}
              height={31}
              width={200}
              className="fill-veni-green-900"
              fill="black"
            />
            <ErrorAlert variant="error" title={<h1 className="">Critical error</h1>}>
              <p className="">A critical error has occured. Please try again later</p>
            </ErrorAlert>
          </div>
        </main>
      </body>
    </html>
  );
};

const GlobalErrorSignout = () => {
  const { data, error } = authClient.useSession();

  if (!data?.session || error) return null;
  return <SignoutButton className="absolute top-12 right-16 rounded-full">Sign out</SignoutButton>;
};

export default GlobalError;
